export const environment = {
  production: true,

  reportingTool: "https://api.catalyzr.io/queryresultsdemo?clientId=",
  baseSignalRUrl: "https://api.catalyzr.io/message",
  baseDownloadUrl: "https://api.catalyzr.io/api/Files/Download?fileName=",
  baseAppImageUrl: "https://api.catalyzr.io/",
  baseS3ImageUrl: "https://api.catalyzr.io/api/s3/getImage?fileName=",
  baseApiUrl: "https://api.catalyzr.io/api/",
  deliveryApi: "https://api.catalyzr.io/api/delivery",
  launchUriApi: "https://api.catalyzr.io/api/delivery/",
  employeeUrl: "https://api.catalyzr.io/api/Employees",
  baseUrl: "https://api.catalyzr.io/",

  baseAuthSignalRUrl: "https://auth.catalyzr.io/message",
  baseAuthUrl: "https://auth.catalyzr.io/api/",
  baseAuthApiURL: "https://auth.catalyzr.io/api/auth/",
  baseAuthServerUrl: "https://auth.catalyzr.io/",

  feedbackUrl: "https://catalyzr.io/employee/feedback",

  reportingUrl: "https://reporting.catalyzr.io",
  baseReportingSignalRUrl: "https://reporting.catalyzr.io/message",

  taoQuestion:
    "https://assessment.catalyzr.io/tao/Main/index?structure=items&ext=taoItems&section=manage_items&uri=https%3A%2F%2Fcatalyzr.io%2Ftao%2Ftaocat.rdf%23i157489052149506",
  taoAssessments:
    "https://assessment.catalyzr.io/tao/Main/index?structure=tests&ext=taoTests&section=manage_tests&uri=https%3A%2F%2Fcatalyzr.io%2Ftao%2Ftaocat.rdf%23i15789847434899258",
  taoDeliveries:
    "https://assessment.catalyzr.io/tao/Main/index?structure=delivery&ext=taoDeliveryRdf&section=manage_delivery_assembly&uri=https%3A%2F%2Fwww.tao.lu%2FOntologies%2FTAODelivery.rdf%23AssembledDelivery",
  baseDomainUrl: "https://catalyzr.io/",
  taoLoginUserName: "admin",
  taoLoginPassword: "admin",
  contractUsToEmailAddress: "Admin@Catalyzr.com",
  addGroup: true,
  groupList: false,
};
